module.exports = __webpack_public_path__ + "static/media/githubLogo.6eeb2e81.png";